import { render } from "./login.vue?vue&type=template&id=3c4aa394&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=3c4aa394&lang=scss&scoped=true"

import exportComponent from "/Users/tangyinbo/workspace/front/syb/syb_webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c4aa394"]])

export default __exports__